import React, { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router';
import { connect, useDispatch } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import AppRouter from './containers/App/AppRouter';
import { AuthRoutes } from './components/Auth/AuthRoutes';
import Login from './containers/Login/Login';
import InitialSignIn from './containers/Login/InitialSignin';
import SetPassword from './containers/Login/SetPassword';
import SimpleLayout from './containers/Layout/SimpleLayout';
import OnboardingContainer from './containers/Onboarding/OnboardingContainer';
import { ERROR_TYPES } from './consts/consts';
import { ErrorPage } from './components/ErrorPage/ErrorPage';
import { validateUser, loginWithMicrosoftAndApproveTermsOfUse, loginWithMicrosoft } from './redux/authentication/slice';
import { getConfig } from './redux/config/slice';
import { selectIsLoggedIn, selectValidateUserLoading } from './redux/authentication/selectors';

const PublicRoutes = ({ getConfig, validateUser, validateUserLoading, isloggedIn }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { instance } = useMsal();

  // On initial load, validate the user token
  useEffect(() => {
    getConfig();
    validateUser();
  }, []);

  // Handle MSAL redirect response
  useEffect(() => {
    const handleRedirect = async () => {
      try {
        const response = await instance.handleRedirectPromise();
        if (response) {
          instance.setActiveAccount(response.account);
          if (location.pathname === '/initial-signin') {
            dispatch(loginWithMicrosoftAndApproveTermsOfUse({ accessToken: response.accessToken, navigate }));
          } else {
            dispatch(loginWithMicrosoft({ accessToken: response.accessToken }));
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error handling MSAL redirect:', error);
      }
    };

    handleRedirect();
  }, [dispatch, instance]);

  // If the user is not logged in, shut down Intercom
  useEffect(() => {
    if (!isloggedIn && window.Intercom) {
      window.Intercom('shutdown');
    }
  }, [isloggedIn]);

  if (validateUserLoading) {
    return <React.Fragment />;
  }

  return (
    <Routes>
      <Route path="/pageNotFound" element={<ErrorPage errorType={ERROR_TYPES.ERROR_PAGE_NOT_FOUND} />} />
      <Route path="/notAllowed" element={<ErrorPage errorType={ERROR_TYPES.ERROR_NOT_AUTHORIZED} />} />
      <Route path="/signin" element={<SimpleLayout component={Login} />} />
      <Route path="/initial-signin" element={<SimpleLayout component={InitialSignIn} />} />
      <Route path="/reset-password" element={<SimpleLayout component={SetPassword} />} />

      <Route path="/onboarding" element={<AuthRoutes component={OnboardingContainer} />} />

      <Route path="/*" element={<AuthRoutes component={AppRouter} />} />
      <Route path="*" element={<ErrorPage errorType={ERROR_TYPES.ERROR_PAGE_NOT_FOUND} />} />
    </Routes>
  );
};

const mapStateToProps = (state) => ({
  isloggedIn: selectIsLoggedIn(state),
  validateUserLoading: selectValidateUserLoading(state)
});

const mapDispatchToProps = {
  getConfig,
  validateUser
};

export default connect(mapStateToProps, mapDispatchToProps)(PublicRoutes);
